import { render } from "./AttachmentModal.vue?vue&type=template&id=4ec1e0a2&scoped=true&ts=true"
import script from "./AttachmentModal.vue?vue&type=script&lang=ts"
export * from "./AttachmentModal.vue?vue&type=script&lang=ts"

import "./AttachmentModal.vue?vue&type=style&index=0&id=4ec1e0a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec1e0a2"]])

export default __exports__